import React, { Component, ReactNode } from 'react';
import Icon from '../icons/Icon';
import { FormicaProps, withFormica } from 'helpers/withFormica';
import Breadcrumb from '../components/Breadcrumb';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { RootState, store } from '../redux/store';
import FolderService from '../service/FolderService';
import ComponentName from '../constant/ComponentName';
import { initialPagePath } from '../redux/reducers/PageReducer';
import { clearPage } from '../redux/actions/PageActions';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import EnvironmentUtil from '../util/EnvironmentUtil';
import CustomTabv2, { CustomTabItem } from '../components/custom/CustomTabv2';
import UserContainer from '../components/admin/user/UserContainer';
import GroupContainer from '../components/admin/group/GroupContainer';
import RoleContainer from '../components/admin/role/RoleContainer';
import AuditManagementContainer from '../components/admin/audit/AuditManagementContainer';
import SessionContainer from '../components/admin/session/SessionContainer';
import { ConfirmPopup } from 'primereact/confirmpopup';
import LanguageUtil from '../util/LanguageUtil';

class AdminContainer extends Component<Props> {
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  public render(): ReactNode {
    const {
      router: { location },
    } = this.props;
    let currentTab = location.pathname.split('/').reverse()[0];
    if (currentTab == 'admin') currentTab = 'user';

    return (
      <div className={'flex flex-col h-full w-full gap-y-5 overflow-hidden'}>
        <Breadcrumb />
        <ConfirmPopup />
        <div className={'flex w-full h-full items-center justify-start'}>
          <CustomTabv2 tab={this.getTabs()} isAdminPage={true} selectedTab={currentTab} onClick={this.onChangePage} />
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    const {
      router: { location },
    } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.ADMINISTRATION];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.ADMINISTRATION, location.pathname, store.getState().page);
    }
  }

  public componentWillUnmount() {
    this.props.clearPage();
  }

  private onChangePage = (e: any, tab: string) => {
    const {
      router: { navigate },
    } = this.props;
    navigate(`/admin/${tab}`);
  };

  private getTabs = (): CustomTabItem[] => {
    return [
      {
        key: 'user',
        label: LanguageUtil.get({ id: 'common.tabs.user', defaultMessage: 'User' }),
        content: <UserContainer />,
        icon: <Icon icon={'admin-icon'} size={16} />,
        testid: `${ComponentName.ADMIN}_user_tab`,
      },
      {
        key: 'group',
        label: LanguageUtil.get({ id: 'common.tabs.group', defaultMessage: 'Group' }),
        content: <GroupContainer />,
        icon: <Icon icon={'group'} size={14} />,
        testid: `${ComponentName.ADMIN}_group_tab`,
      },
      {
        key: 'role',
        label: LanguageUtil.get({ id: 'common.tabs.role', defaultMessage: 'Role' }),
        content: <RoleContainer />,
        icon: <Icon icon={'key'} size={14} />,
        testid: `${ComponentName.ADMIN}_role_tab`,
      },
      {
        key: 'audit',
        label: LanguageUtil.get({ id: 'common.tabs.audit', defaultMessage: 'Audit' }),
        content: <AuditManagementContainer />,
        icon: <Icon icon={'audit-icon'} size={16} />,
        visible: this.environmentUtil.isAuditLogVisible(),
        testid: `${ComponentName.ADMIN}_audit_tab`,
      },
      {
        key: 'sessions',
        label: LanguageUtil.get({ id: 'common.tabs.sessions', defaultMessage: 'Sessions' }),
        content: <SessionContainer />,
        icon: <Icon icon={'audit-icon'} size={16} />,
        testid: `${ComponentName.ADMIN}_session_tab`,
      },
    ];
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  currentCategory: state.page.currentCategory,
  pagePath: state.page.pagePath,
  categoryPages: state.category.pages,
  activePageIndex: state.page.activePageIndex,
  enrichedCategories: state.page.enrichedCategories,
});

const connector = connect(mapStateToProps, { clearPage });
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(AdminContainer));
